<div class="product__box__mobile has-text-centered" *ngIf="mobile" (click)="selectEvent.emit(package.name)">
  <div>
                <span class=" has-text-centered" style="font-size: 82%">
                    {{package.name}}
                </span>
  </div>
  <div style="margin-bottom: 10px">
         <span class="icon is-large mt-5" >
            <img alt="Package Logo" src="{{package.logo}}"  [ngClass]="{'product__box__button_selected' : package.selected}">
        </span>
  </div>

  <div class=" has-text-centered">€ {{package.price}} / {{package.priceUnit}}</div>


</div>
